/**
 * Module dependencies
 */

var Context = module.exports = require('./lib/context');
var Emitter = require('emitter-component');

/**
 * Mixin the emitter
 */

Emitter(Context.prototype);



/*****************
 ** WEBPACK FOOTER
 ** ./~/superagent-defaults/index.js
 ** module id = 565
 ** module chunks = 0
 **/